import React from 'react';
import PropTypes from 'prop-types';

const Download = ({ fill, theme, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.51 9.74H15.31V3.63C15.31 3.4974 15.2573 3.37022 15.1636 3.27645C15.0698 3.18268 14.9426 3.13 14.81 3.13H9.19C9.05739 3.13 8.93021 3.18268 8.83645 3.27645C8.74268 3.37022 8.69 3.4974 8.69 3.63V9.74H5.49C5.39007 9.7394 5.29225 9.76876 5.20916 9.82428C5.12607 9.87981 5.06153 9.95896 5.02386 10.0515C4.98619 10.1441 4.97712 10.2458 4.99782 10.3436C5.01852 10.4413 5.06804 10.5307 5.14 10.6L11.65 17.11C11.7435 17.2016 11.8691 17.2529 12 17.2529C12.1309 17.2529 12.2565 17.2016 12.35 17.11L18.86 10.6C18.932 10.5307 18.9815 10.4413 19.0022 10.3436C19.0229 10.2458 19.0138 10.1441 18.9761 10.0515C18.9385 9.95896 18.8739 9.87981 18.7908 9.82428C18.7077 9.76876 18.6099 9.7394 18.51 9.74ZM10.9 12V5.33H13.1V12H14.39L12 14.34L9.61 12H10.9ZM5.38 18.67H18.62C18.7645 18.67 18.9075 18.6985 19.041 18.7537C19.1744 18.809 19.2957 18.89 19.3978 18.9922C19.5 19.0943 19.581 19.2156 19.6363 19.3491C19.6915 19.4825 19.72 19.6255 19.72 19.77C19.72 19.9145 19.6915 20.0575 19.6363 20.191C19.581 20.3244 19.5 20.4457 19.3978 20.5478C19.2957 20.65 19.1744 20.731 19.041 20.7863C18.9075 20.8416 18.7645 20.87 18.62 20.87H5.38C5.08826 20.87 4.80847 20.7541 4.60218 20.5478C4.39589 20.3415 4.28 20.0617 4.28 19.77C4.28 19.4783 4.39589 19.1985 4.60218 18.9922C4.80847 18.7859 5.08826 18.67 5.38 18.67Z"
      fill={fill || theme.COLORS.primary}
    />
  </svg>
);

Download.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Download;
